var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subheading"},[_c('span',[_vm._v(_vm._s(_vm.formattedEntry))]),(_vm.entry.stashIcon)?_c('v-avatar',{staticClass:"itemIcon",attrs:{"tile":"","size":30}},[_c('img',{attrs:{"src":_vm.entry.stashIcon}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }